import React, { useEffect, useState } from 'react';
import useStore from '../../services/hooks/useStore';
import { MenuGrade, HomeLink, Body, SquareContainer } from './styles';
import { useHistory } from 'react-router-dom';
import { permissoes } from '../../services/utils/permissoes';
import styled from 'styled-components';
import { aqReportsV2 } from '../../services/utils';
import NotificacaoService from '../../services/NotificacaoService';
import NotificationBar from '../../components/NotificationBar';

const MainContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 80vh;
  gap: 60px;
`;

const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 400px;
  height: 400px;
`;

const IndicadoresContainer = styled.div`
  width: 500px;
  height: 400px;
  background: #fff;
  border: 1px solid #bdbdbd;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  overflow: hidden;
`;

const IndicadoresTitulo = styled.div`
  background-color: #42a5f5;
  color: white;
  font-size: 24px;
  padding: 10px 20px;
  height: 45px;
  display: flex;
  align-items: center;
  font-weight: 500;
`;

const IndicadoresContent = styled.div`
  padding: 20px;
  max-height: 355px;
  overflow-y: auto;
  
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

const IndicadorSecao = styled.div`
  margin-bottom: 10px;
`;

const IndicadorLabel = styled.div`
  font-weight: 500;
  width: 100%;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  margin-bottom: 2px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 10px;
`;

const ListaPrecos = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const ListaCabecalho = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #e0e0e0;
  color: #666;
  font-size: 13px;
  font-weight: 500;
`;

const ItemPreco = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  padding: 2px 0;
  border-bottom: 1px solid #f0f0f0;
  &:last-child { border-bottom: none; }
`;

const ColunaProduto = styled.span`
  width: 230px;
  padding-right: 8px;
`;

const ColunaData = styled.span`
  width: 100px;
  text-align: center;
`;

const ColunaPreco = styled.span`
  width: 100px;
  text-align: right;
`;

const ProdutoInfo = styled(ColunaProduto)`
  color: #222;
`;

const DataInfo = styled(ColunaData)`
  font-size: 13px;
  color: #888;
`;

const PrecoInfo = styled(ColunaPreco)`
  font-weight: 600;
  color: #222;
`;

interface BotaoToggleProps {
  isOpen?: boolean;
}

const BotaoToggle = styled.button<BotaoToggleProps>`
  background: none;
  border: none;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.54);
  padding: 0;
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  margin-right: -12px;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
    border-radius: 50%;
  }

  &::after {
    content: '';
    border-left: 5px solid rgba(0, 0, 0, 0.54);
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    transform: ${props => props.isOpen ? 'rotate(90deg)' : 'rotate(0)'};
    display: inline-block;
    transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }
`;

const Home: React.FC = () => {
  const store = useStore();
  const history = useHistory();
  const [dados, setDados] = useState<{ produto: string; preco: string; data: string }[]>([]);
  const [openTilapia, setOpenTilapia] = useState(true);
  const [openTambaqui, setOpenTambaqui] = useState(false);
  const [openCamarao, setOpenCamarao] = useState(false);
  const [dadosAquabit, setDadosAquabit] = useState<any[]>([]);

  useEffect(() => {
    const funcionGetNewDatos = async () => {
      const dadosSalvos = localStorage.getItem('dados');
      if (dadosSalvos) {
        setDados(JSON.parse(dadosSalvos));
      }

      const props = await aqReportsV2.get(`/vendas/media-por-especie-regiao`, {
        headers: {
          Authorization: `${store.token}`
        }
      });

      setDadosAquabit(props.data);

      // Buscar notificações
      try {
        const propriedadeId = Number(localStorage.getItem('propriedade'));
        if (propriedadeId) {
          const notificacoes = await NotificacaoService.buscarNotificacoes(propriedadeId);
          store.setNotificacoes(notificacoes);
          store.setNotificacoesNaoLidas(notificacoes.filter(n => !n.lido).length);
          
          
        }
      } catch (error) {
        console.error('Erro ao buscar notificações:', error);
      }
    }

    funcionGetNewDatos();
  }, []);
// eslint-disable-next-line
useEffect(() => store.setTitulo(''), []);
  const formatarPreco = (valor: string) => {
    return `R$/KG ${Number(valor).toFixed(2).replace('.', ',')}`;
  };

  const filtrarPorEspecie = (especie: string) => {
    return dadosAquabit
      .filter(item => item.especie === especie)
      .map(item => ({
        produto: `${item.especie} - ${item.regiao}`,
        data: item.data_venda,
        preco: formatarPreco(item.valor_por_quilo)
      }));
  };

  return (
    <>
    <NotificationBar />
    <Body>
      <p>Olá, {store.usuario.nome || 'Usuário'}</p>
      <h2>O que deseja fazer hoje?</h2>
      <MainContainer>
        <MenuContainer>
          <MenuGrade style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gridTemplateRows: 'repeat(2, 1fr)',
            gap: '15px',
            width: '100%',
            height: '100%',
            background: 'none',
            boxShadow: 'none',
            border: 'none',
            padding: 0
          }}>
            <HomeLink
              onClick={() => {
                if (store.checkPermissions(permissoes.PROPRIEDADE_LEITURA)) history.push('/propriedade/tanques');
                else store.notificar('Você não tem permissão para acessar este módulo!');
              }}
            >
              <SquareContainer>
                <img src="/images/propriedade.svg" alt="Tanques/Viveiros" />
              </SquareContainer>
              Tanques/Viveiros
            </HomeLink>
            <HomeLink
              onClick={() => {
                if (store.checkPermissions(permissoes.PRODUCAO_POVOAMENTO_LEITURA)) history.push('/producao/povoamento');
                else store.notificar('Você não tem permissão para acessar este módulo!');
              }}
            >
              <SquareContainer>
                <img src="/images/producao.svg" alt="Produção" />
              </SquareContainer>
              Produção
            </HomeLink>
            <HomeLink
              onClick={() => {
                if (store.checkPermissions(permissoes.CONTROLE_RACAO_ARRACOAMENTO_LEITURA))
                  history.push('/producao/arracoamento');
                else store.notificar('Você não tem permissão para acessar este módulo!');
              }}
            >
              <SquareContainer>
                <img src="/images/arracoamento.svg" alt="Arraçoamento" />
              </SquareContainer>
              Arraçoamento
            </HomeLink>
            <HomeLink
              onClick={() => {
                if (store.checkPermissions(permissoes.VENDAS_MINHAS_VENDAS_LEITURA)) history.push('/vendas');
                else store.notificar('Você não tem permissão para acessar este módulo!');
              }}
            >
              <SquareContainer>
                <img src="/images/venda.svg" alt="Vendas" />
              </SquareContainer>
              Vendas
            </HomeLink>
            <HomeLink
              onClick={() => {
                if (store.checkPermissions(permissoes.FINANCEIRO_PAINEL_FINANCEIRO_LEITURA))
                  history.push('/financeiro/painel/dashboard');
                else store.notificar('Você não tem permissão para acessar este módulo!');
              }}
            >
              <SquareContainer>
                <img src="/images/financeiro.svg" alt="Financeiro" />
              </SquareContainer>
              Financeiro
            </HomeLink>
            <HomeLink
              onClick={() => {
                if (store.checkPermissions(permissoes.QUALIDADE_E_SANIDADE_QUALIDADE_DA_AGUA_LEITURA))
                  history.push('/qualidade-da-agua');
                else store.notificar('Você não tem permissão para acessar este módulo!');
              }}
            >
              <SquareContainer>
                <img src="/images/qualidade_da_agua.svg" alt="Qualidade da Água" />
              </SquareContainer>
              Qualidade da Água
            </HomeLink>
          </MenuGrade>
        </MenuContainer>
        <IndicadoresContainer>
          <IndicadoresTitulo>Indicadores de Preços</IndicadoresTitulo>
          <IndicadoresContent>
            <IndicadorSecao>
              <IndicadorLabel onClick={() => setOpenTilapia((v) => !v)}>
                CEPEA - Tilápia
                <BotaoToggle isOpen={openTilapia} />
              </IndicadorLabel>
              {openTilapia && (
                <>
                  <ListaCabecalho>
                    <ColunaProduto>Produto</ColunaProduto>
                    <ColunaData>Data</ColunaData>
                    <ColunaPreco>Preço</ColunaPreco>
                  </ListaCabecalho>
                  <ListaPrecos>
                    {dados.length > 0 ? dados.map((item, idx) => (
                      <ItemPreco key={idx}>
                        <ProdutoInfo>{item.produto}</ProdutoInfo>
                        <DataInfo>{item.data}</DataInfo>
                        <PrecoInfo>{item.preco}</PrecoInfo>
                      </ItemPreco>
                    )) : <li style={{ color: '#aaa', fontSize: 13 }}>Sem dados</li>}
                  </ListaPrecos>
                </>
              )}
            </IndicadorSecao>
            <IndicadorSecao>
              <IndicadorLabel onClick={() => setOpenTambaqui((v) => !v)}>
                AQUABIT - Peixes

                <BotaoToggle isOpen={openTambaqui} />
              </IndicadorLabel>
              {openTambaqui && (
                <>
                  <ListaCabecalho>
                    <ColunaProduto>Produto</ColunaProduto>
                    <ColunaData>Data</ColunaData>
                    <ColunaPreco>Preço</ColunaPreco>
                  </ListaCabecalho>
                  <ListaPrecos>
                    {
                      dadosAquabit.length > 0 ? (
                        dadosAquabit.sort((a,b)=>a.especie.localeCompare(b.especie)).filter(item=>item.especie !== 'Camarão').map((item, idx) => (
                          <ItemPreco key={idx}>
                            <ProdutoInfo>{item.especie} - {item.regiao}</ProdutoInfo>
                            <DataInfo>{item.data_venda}</DataInfo>
                            <PrecoInfo>{formatarPreco(item.valor_por_quilo)}</PrecoInfo>
                          </ItemPreco>
                        ))
                      ) : (
                        <li style={{ color: '#aaa', fontSize: 13 }}>Sem dados</li>
                      )}
                  </ListaPrecos>
                </>
              )}
            </IndicadorSecao>,
            <IndicadorSecao>
              <IndicadorLabel onClick={() => setOpenCamarao((v) => !v)}>
              AQUABIT - Camarão
                <BotaoToggle isOpen={openCamarao} />
              </IndicadorLabel>
              {openCamarao && (
                <>
                  <ListaCabecalho>
                    <ColunaProduto>Produto</ColunaProduto>
                    <ColunaData>Data</ColunaData>
                    <ColunaPreco>Preço</ColunaPreco>
                  </ListaCabecalho>
                  <ListaPrecos>
                    {filtrarPorEspecie('Camarão').length > 0 ? (
                      filtrarPorEspecie('Camarão').map((item, idx) => (
                        <ItemPreco key={idx}>
                          <ProdutoInfo>{item.produto}</ProdutoInfo>
                          <DataInfo>{item.data}</DataInfo>
                          <PrecoInfo>{item.preco}</PrecoInfo>
                        </ItemPreco>
                      ))
                    ) : <li style={{ color: '#aaa', fontSize: 13 }}>Sem dados</li>}
                  </ListaPrecos>
                </>
              )}
            </IndicadorSecao>
          </IndicadoresContent>
        </IndicadoresContainer>
      </MainContainer>
    </Body>
    </>
  );
};

export default Home;
